import React from 'react';

const Citations = () => {
  // Dataset citations data
  const datasets = [
    {
      name: "IFM 2009 RNAseq",
      citations: [
        {
          text: "Long intergenic non-coding RNAs have an independent impact on survival in multiple myeloma. Samur MK, Minvielle S, Gulla A, Fulciniti M, Cleynen A, Aktas Samur A, Szalat R, Shammas M, Magrangeas F, Tai YT, Auclair D, Keats J, Richardson P, Attal M, Moreau P, Anderson KC, Parmigiani G, Avet-Loiseau H, Munshi NC. Leukemia. 2018 Dec;32(12):2626-2635. doi: 10.1038/s41375-018-0116-y. Epub 2018 Mar 29. PMID: 29749396",
          url: "https://pubmed.ncbi.nlm.nih.gov/29749396/"
        }
      ]
    },
    {
      name: "IFM 2009 WGS",
      citations: [
        {
          text: "Genome-Wide Somatic Alterations in Multiple Myeloma Reveal a Superior Outcome Group. Samur MK, Aktas Samur A, Fulciniti M, Szalat R, Han T, Shammas M, Richardson P, Magrangeas F, Minvielle S, Corre J, Moreau P, Thakurta A, Anderson KC, Parmigiani G, Avet-Loiseau H, Munshi NC. J Clin Oncol. 2020 Sep 20;38(27):3107-3118. doi: 10.1200/JCO.20.00461. Epub 2020 Jul 20. PMID: 32687451",
          url: "https://pubmed.ncbi.nlm.nih.gov/32687451/"
        },
        {
          text: "Development of hyperdiploidy starts at an early age and takes a decade to complete. Samur MK, Aktas Samur A, Shah P, Park JS, Fulciniti M, Shammas M, Corre J, Anderson KC, Parmigiani G, Avet-Loiseau H, Munshi NC. Blood. 2025 Jan 30;145(5):520-525. doi: 10.1182/blood.2024025250. PMID: 39571146",
          url: "https://pubmed.ncbi.nlm.nih.gov/39571146/"
        }
      ]
    },
    {
      name: "SMM and MGUS Precursors",
      citations: [
        {
          text: "Coming soon...",
          url: "https://pubmed.ncbi.nlm.nih.gov/"
        }
      ]
    }
  ];


  return (
    <div className="citations-page">
      <h1>Citations and Acknowledgments</h1>
      
      {/* Group Picture Placeholder */}
      <div className="group-picture">
  		<img 
    		src="/TeamGroupPhoto.jpg" 
    		alt="DFCI Multiple Myeloma Research Team" 
    		className="team-photo"
  		/>
	  </div>
      
      {/* Thank You Message */}
      <div className="contact-container acknowledgment-box">
        <h2>Acknowledgments</h2>
        <p>
          We would like to extend our sincere gratitude to all the research groups, collaborative studies, and funding 
          providers who have contributed to the datasets available on this portal. The advancement of multiple myeloma 
          research would not be possible without the dedication and collaboration of numerous scientists, clinicians, 
          and patients who participated in these studies.
        </p>
        <p>
          Special thanks to our international collaborators, the IFM group, and all 
          participating institutions that have shared their valuable data to accelerate discoveries in multiple myeloma 
          research. We also acknowledge the generous support from our funding agencies that make this work possible.
        </p>
{/* Project Team Information */}
<div className="team-information">
  
  <div className="team-section">
    <h2>Project Leaders</h2>
    <div className="team-members-row">
      <ul className="team-members">
        <li><span className="member-name">Mehmet Samur, PhD</span> -- DFCI</li>
        <li><span className="member-name">Jill Corre, PharmD, PhD</span> -- IFM</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Nikhil Munshi, MD</span> -- DFCI</li>
        <li><span className="member-name">Kenneth C. Anderson, MD</span> -- DFCI</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Herve Avet-Loiseau, MD, PhD</span> -- IFM</li>
        <li><span className="member-name">Paul Richardson, MD</span> -- DFCI</li>
      </ul>
    </div>
  </div>
  
  <div className="team-section">
    <h2>Data Analysis, Preparation and Development</h2>
    <div className="team-members-row">
      <ul className="team-members">
        <li><span className="member-name">Anil Aktas Samur, PhD</span> -- DFCI</li>
        <li><span className="member-name">Joshua Rivera, PhD</span> -- DFCI</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Parth Shah, MD</span> -- Dartmouth</li>
        <li><span className="member-name">Yiyang Fan</span> -- DFCI</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Luka Pavageau, MSc</span> -- Toulouse</li>
      </ul>
    </div>
  </div>
  
  <div className="team-section">
    <h2>Project Team</h2>
    <div className="team-members-row">
      <ul className="team-members">
        <li><span className="member-name">Mariateresa Fulciniti, PhD</span> -- DFCI</li>
        <li><span className="member-name">Rao H. Prabhala, PhD</span> -- DFCI</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Masood Shammas, PhD</span> -- DFCI</li>
        <li><span className="member-name">Srikanth Talluri, PhD</span> -- DFCI</li>
      </ul>
      <ul className="team-members">
        <li><span className="member-name">Eugenio Morelli, PhD</span> -- DFCI</li>
        <li><span className="member-name">Laure Buisson, MSc</span> -- Toulouse</li>
      </ul>
    </div>
  </div>
</div>
      </div>
      
      {/* Funding Provider Logos */}
<div className="funding-providers">
  <h2>Funding Providers</h2>
  <div className="logo-grid">

    {/* Second provider with actual logo */}
    <div className="logo-container-funding">
      <img 
        src="https://paulaandrodgerrineyfoundation.org/wp-content/uploads/2021/12/logo-web.png" 
        alt="Paula & Rodger Riney Foundation" 
        className="provider-logo-funding"
      />
    </div>
    
    
  </div>
</div>
      
      {/* Dataset Citations */}
      <div className="dataset-citations">
        <h2>Dataset Citations</h2>
        <p className="citation-instruction">
          If you use data from this portal in your research, please cite the relevant publications listed below.
        </p>
        
        {datasets.map((dataset, index) => (
          <div key={index} className="dataset-citation-box">
            <h3>{dataset.name}</h3>
            <ul className="citation-list">
              {dataset.citations.map((citation, citIndex) => (
                <li key={citIndex} className="citation-item">
                  <div className="citation-text">
                    {citation.text}
                  </div>
                  <a 
                    href={citation.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="pubmed-link"
                  >
                    View on PubMed
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Citations;